import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

import useTranslation from '../../hooks/use_translation';
import Link from '../framework/link';
import SectionHeader from '../framework/sections/section-header';

const PrivacyComponent = () => {
	const { t } = useTranslation('component_privacy');

	return (
		<div className="container">
			<div className="row align-items-start justify-content-center">
				<div className="col-auto">
					<StaticImage
						alt=""
						className="img-fluid  mb-2 "
						src="../../images/icons/gdpr.svg"
						style={{ height: '50px', width: '50px' }}
					/>
				</div>
				<div className="col-md-6">
					<SectionHeader
						headingType="h3"
						hideButton={true}
						resetSpacing
						title={t('t1')}
					/>
					<p className="mt-3">{t('t2')}</p>

					<Link to="/villkor/integritetspolicy/">{t('t3')}</Link>
				</div>
			</div>
		</div>
	);
};

export default PrivacyComponent;
